/**
 * Mock data for the acquisition "Suggested Campaign" detail page.
 * Temporary — remove when the page is wired to an API (see docs/mock-data.md).
 */
import type { SuggestedCampaignData } from './types';

const ART_1 = '/assets/marketing/campaign-spooky-1.png';
const ART_2 = '/assets/marketing/campaign-spooky-2.png';

export const suggestedCampaignData: SuggestedCampaignData = {
  header: { title: 'Suggested Campaign Details' },
  periodLabel: 'Campaign Duration: October 22 - October 30',
  intro: 'This is the right moment to bring more players on the site with a Halloween promo campaign.',
  offering: {
    title: '100 Free Spooky Spins',
    badge: { label: 'Free campaign', tone: 'success' },
    description:
      'Looking for a spooky treat? Make a deposit to unlock a fantastic bonus: 100 Free Spins. Use them on our most popular, selected Halloween games and spin for some ghoulishly good wins!',
    channelsLabel: 'Activate this campaign and get promoted on popular websites like:',
    channels: [
      { id: 'website', label: 'Website Name' },
      { id: 'app', label: 'App Name' },
      { id: 'crypto', label: 'Crypto Portal Name' },
    ],
    moreCount: 10,
  },
  styleStep: {
    options: [
      { id: 'option-1', label: 'OPTION 1', image: ART_1 },
      { id: 'option-2', label: 'OPTION 2', image: ART_2 },
    ],
  },
  warning: 'This campaign will become outdated in just 8 hours.',
};

export default suggestedCampaignData;
